declare global {
  interface Window {
    OnetrustActiveGroups?: string
  }
}

export const ADVERTISING_GROUP = 'C0004'

export function hasAdvertisingConsent(): boolean {
  if (typeof window === 'undefined') return false
  const groups = window.OnetrustActiveGroups
  if (typeof groups !== 'string') return false
  return groups.indexOf(ADVERTISING_GROUP) !== -1
}
